import { BannerComponent, BookingComponent } from "../../components";
import Breadcrumb from "./components/Breadcrumb";
import ServiceHotel from "./components/ServiceHotel";
import SmartRoom from "./components/SmartRoom";
import SpaceRelax from "./components/SpaceRelax";
import UtilitiesList from "./components/UtilitiesList";

function Experiences() {
  return (
    <div className="experiences">
      <BannerComponent />
      <BookingComponent />
      <Breadcrumb />
      <UtilitiesList />
      <SmartRoom />
      <SpaceRelax />
      <ServiceHotel />
    </div>
  );
}
export default Experiences;
